export default [{text: '支出', type: '-'},
    {text: '收入', type: '+'}
];
